import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { ALIMTALK_SEND_PAGE_NAME } from '../../views/alimtalk/send/history/constants';
import AlimtalkSendHistoryDetailWrap from '../../views/alimtalk/send/history/components/AlimtalkSendHistoryDetailWrap';

/**
 *  알림톡 발송 상세정보 페이지
 */
const AlimtalkSendHistoryDetail = (): JSX.Element => {
  return (
    <PageTemplate pageName={ALIMTALK_SEND_PAGE_NAME.HISTORY_DETAIL}>
      <AlimtalkSendHistoryDetailWrap />
    </PageTemplate>
  );
};

export default AlimtalkSendHistoryDetail;
